module.exports = __webpack_public_path__ + "img/Incheon-Motors.2a496ffe.jpg";